const BASE_URL = "http://localhost:9777";
const API_BASE_URL_QA = "https://qa.svkpgbookings.com";

export const API = {
  // Public APIs
  V2: `${API_BASE_URL_QA}/v2`,

  // Secured APIs
  V1: `${API_BASE_URL_QA}/v1`,
};

export default API;
